
import { WOW } from "wowjs";

(function ($) {
	
	$(document).ready(function () {

		const wow = new WOW();

		wow.init();

		// Watch for when header is scrolled to or away from the top of the viewport
		// If header is scrolled to the top of the page, we know it's been stickied based on it having position: sticky
		// Add class when it's sitting at the top of the page, remove it when it's been scrolled away
		$("body > header").observeScrollTopChanges().on("scroll-top-change", (evt) => {

			$(evt.target).toggleClass("sticky", evt.detail.scrolledToTop);

		});

		// TODO Steps to fix issue with bottom divider being behind next sibling:
		// 1. Iterate through blocks in reverse order
		// 2. For each block, get it's current z-index value and compare to next sibling's z-index value
		// 3. If the current block's z-index is smaller, set it to be one higher than the next sibling's z-index
		// 4. If the next sibling is not visible or has height less than divider height, check the next sibling and perform steps 2. and 3.
		// 5. Keep performing step 2. until siblings' height is greater than divider height
		/*var bottomDividerBlocks = $(".orange-block.block-divider-wave-onbottom");

		bottomDividerBlocks.each(function(i){


		});*/

		/**
		 * Back to top button - scroll functionality
		 */
		$("#back-to-top").on("click", function(){
			$("html, body").animate({
				scrollTop: 0,
			}, 400);
		});

	});

	// Fires event when element has scrolled up to or away from the top of it's parent
	$.fn.observeScrollTopChanges = function() {

		// Top and bottom margin values position marker element at the top of the box area of the current element, regardless of it's top margin
		// Need to increase bottom margin's negative value by 1px to compensate for marker's height
		// Essentially makes the marker invisible
		const marker = $("<div>").css({
			"margin-top":       this.css("marginTop"),
			"margin-bottom":    ((parseInt(this.css("marginTop")) + 1) * -1),
			"height":           "1px",
		});

		// Add to DOM before element being observed
		// When marker is hidden beyond the top of the viewport, the target element will be touching the top of the viewport
		this.before(marker);

		// Create observer object
		const scrollTopObserver = new IntersectionObserver((entries) => {

			// Width, height and scroll position of element being observed
			const targetBoundingRect = entries[0].boundingClientRect;
			// Width height and position of viewport
			const viewportBoundingRect = entries[0].rootBounds;

			// The element that should have the event triggered on it
			// Basically, the element that we want to know when it has reached the top of the page on scroll
			const evtTrigger = entries[0].target.nextSibling;

			let scrolledToTop = false;

			// If the entire marker element has scrolled beyond the top of the viewport
			if(targetBoundingRect.bottom < viewportBoundingRect.top){

				scrolledToTop = true;

			// If the entire marker element is visible again
			}else if(targetBoundingRect.bottom >= viewportBoundingRect.top){

				scrolledToTop = false;

			}

			// Create custom event and pass information about whether the element was just hit the top of the page or if it is being scrolled away
			const evt = new CustomEvent("scroll-top-change", {detail: {scrolledToTop: scrolledToTop}});

			evtTrigger.dispatchEvent(evt);

		// Threshold says how much of the element needs to be visible before checking for intersection
		// 0 means as soon as any part of the element is visible
		}, {threshold: [0]});

		// Start observing the marker element
		scrollTopObserver.observe(marker.get(0));

		// Return current element to allow for jQuery function chaining
		return this;

	};

})(jQuery);